export const REJECTED_BROWSER_LOCALE = 'he-IL'
export const FALLBACK_LOCALE = 'en-US'
export const LEBANON_ARABIC_LOCALE = 'ar-LB'
export const ARABIC_LOCALE = 'ar'

function normalizeLocale(browserLocale: string | null | undefined): string {
  return String(browserLocale || '')
    .trim()
    .replace(/_/g, '-')
}

/** Browser auto-select only. A saved `lang` choice stays as the user set it. */
export function resolveBrowserLocale(browserLocale: string | null | undefined): string {
  const normalized = normalizeLocale(browserLocale)
  const lower = normalized.toLowerCase()

  if (lower === REJECTED_BROWSER_LOCALE.toLowerCase()) {
    return FALLBACK_LOCALE
  }
  if (lower === LEBANON_ARABIC_LOCALE.toLowerCase()) {
    return ARABIC_LOCALE
  }
  return normalized
}

/** Translation files are `en` / `ar` / `ku`. `en-US` uses the English pack. */
export function toPanelLanguage(resolvedLocale: string): string {
  if (resolvedLocale.toLowerCase() === FALLBACK_LOCALE.toLowerCase()) {
    return 'en'
  }
  const primary = resolvedLocale.split('-')[0]
  return primary || 'en'
}

export function hasManualLocaleOverride(): boolean {
  try {
    return Boolean(localStorage.getItem('lang'))
  } catch {
    return false
  }
}
